document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');
if (menuButton && mobileNav) {
  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!isOpen));
    menuButton.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
    mobileNav.hidden = isOpen;
    document.body.classList.toggle('menu-open', !isOpen);
  });
}

document.querySelectorAll('[data-wishlist]').forEach((button) => {
  button.addEventListener('click', () => {
    const saved = button.classList.toggle('is-saved');
    button.textContent = saved ? '♥' : '♡';
    button.setAttribute('aria-label', saved ? 'Saved to your wishlist' : 'Save this item');
  });
});

const toast = document.querySelector('[data-toast]');
document.querySelectorAll('.quick-add-form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('button');
    submit.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetch('/cart.js').then((result) => result.json());
      document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
      if (toast) { toast.textContent = 'Added to your bag ✦'; toast.classList.add('is-visible'); setTimeout(() => toast.classList.remove('is-visible'), 2400); }
    } catch (error) { form.submit(); }
    finally { submit.disabled = false; }
  });
});
